import { get } from 'lodash-es';

const BODY_TYPES = ['SUV', 'Sedan', 'Hatchback', 'Minivan', 'Station Wagon', 'Full Size Van', 'Pickup'];

export function getEngineAttrIcon({ vehicleInfo, showElectricityRange }) {
  if (showElectricityRange) {
    return 'icon-low-miles';
  }

  const bodyType = get(vehicleInfo, 'styleInfo.bodyType');
  return BODY_TYPES.includes(bodyType) ? 'icon-cog7' : 'icon-tree7';
}
